<template>
  <div v-if="showIntroBanner" :class="classes()">
    <div :class="`${el}__inner`" :style="`margin-bottom: ${bottomSpace}px`">
      <div :class="`${el}__bar`">
        <Icon
          :name="iconName"
          size="xl"
          :color="highlightColor === 'supportInfo' ? 'neutral0' : 'tertiaryDark'"
        />
        <Icon
          v-if="!$matchMedia.l && !notCloseable"
          name="close-line"
          size="xl"
          :color="highlightColor === 'supportInfo' ? 'neutral0' : 'tertiaryDark'"
          :onClick="onClick"
        />
      </div>
      <div :class="`${el}__content`">
        <Headline size="xs" noMargin>{{ headline }}</Headline>
        <Copy v-if="copy" :staticClass="`${el}__copy`" size="l">
          {{ copy }}
        </Copy>
        <ul v-if="list" :class="`${el}__list`">
          <li v-for="(item, idx) in list" :key="`infobanner-list-${idx}`">
            {{ item }}
          </li>
        </ul>
        <slot />
      </div>
      <Icon
        v-if="$matchMedia.l && !notCloseable"
        :class="`${el}__close`"
        name="close-line"
        size="xl"
        color="primaryBlue"
        :onClick="onClick"
      />
    </div>
  </div>
</template>

<script>
import Headline from '@/objects/Headline';
import Copy from '@/objects/Copy';
import Icon from '@/objects/Icon';

import {
  LS_APPLICATIONS_INFO_BANNER,
  LS_CARE_LEVEL_ANALYSIS_INFO_BANNER,
  LS_CAREPROFILE_INFO_BANNER,
  LS_PFLEGELEISTUNGEN_INFO_BANNER,
  LS_PFLEGELEISTUNGSFINDER_INFO_BANNER,
  LS_PROFILE_INFO_BANNER,
  LS_TASK_SCHEDULER_INFO_BANNER,
} from '@/constants/storage';

import { createTrackingData } from '@/helpers/tracking/utils/helpers';

export default {
  name: 'IntroBanner',
  components: {
    Headline,
    Copy,
    Icon,
  },
  props: {
    headline: {
      type: String,
      required: true,
    },
    copy: {
      type: String,
    },
    list: {
      type: Array,
    },
    bottomSpace: {
      type: Number,
      default: 0,
    },
    iconName: {
      type: String,
      default: 'information-line',
    },
    highlightColor: {
      type: String,
      default: 'supportInfo',
      validator: (val) => ['supportInfo', 'supportWarning'].includes(val),
    },
    notCloseable: {
      type: Boolean,
      default: false,
    },
    hide: {
      type: Boolean,
      default: false,
    },
    localStorage: {
      type: String,
    },
  },
  data() {
    const lsInfoBanner = localStorage.getItem(this.localStorage);

    return {
      hidden: this.hide,
      el: 'c-introBanner',
      showIntroBanner: lsInfoBanner ? JSON.parse(lsInfoBanner) : true,
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--hidden`]: this.hidden,
          [`${el}--${this.highlightColor}`]: this.highlightColor,
        };
      },
    };
  },
  watch: {
    hide() {
      this.hidden = this.hide;
    },
  },
  methods: {
    onClick() {
      this.hidden = true;
      this.$emit('close');

      if (this.localStorage) {
        this.closeIntroBanner();
      }
    },

    closeIntroBanner() {
      localStorage.setItem(this.localStorage, false);

      if (this.localStorage) {
        const product = {
          [LS_APPLICATIONS_INFO_BANNER]: 'Antrag',
          [LS_CARE_LEVEL_ANALYSIS_INFO_BANNER]: 'Pflegegradanalyse',
          [LS_CAREPROFILE_INFO_BANNER]: 'Pflegeprofil',
          [LS_PFLEGELEISTUNGEN_INFO_BANNER]: 'Pflegeleistungsanalyse',
          [LS_PFLEGELEISTUNGSFINDER_INFO_BANNER]: 'Pflegeleistungsfinder',
          [LS_PROFILE_INFO_BANNER]: 'Account',
          [LS_TASK_SCHEDULER_INFO_BANNER]: 'Aufgabenplaner',
        }[this.localStorage];

        if (product) {
          createTrackingData(product, `${product}-Intromodul_click-schließen`, 'element');
        }
      }
    },
  },
};
</script>
